import api from './api';

const ENDPOINT = 'store-highlights';

const ProductHighlightService = {
  get: () => api.get(ENDPOINT),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
};

export default ProductHighlightService;
